// Corporate travel destinations — one SEO page per country
// Each destination targets: "team building [pays]", "voyage entreprise [pays]", "incentive [pays]"

export const DESTINATIONS = {
  maroc: {
    slug: "maroc",
    name: "Maroc",
    flag: "🇲🇦",
    tagline: "Le raffinement oriental à 3h de Paris.",
    hero: "https://images.pexels.com/photos/2528088/pexels-photo-2528088.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/1631665/pexels-photo-1631665.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/12461828/pexels-photo-12461828.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/4394652/pexels-photo-4394652.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Maroc, voyage incentive Marrakech Essaouira Agadir. Organisation clé-en-main de séminaires d'entreprise au Maroc — Riads privatisés, désert d'Agafay, Atlas.",
    seoKeywords:
      "team building Maroc, voyage entreprise Maroc, incentive Marrakech, séminaire Maroc, voyage incentive Essaouira, team building Marrakech, séminaire entreprise Marrakech, voyage groupe Maroc, incentive Atlas, voyage incentive Sahara",
    intro:
      "À seulement 3h de vol de Paris, le Maroc offre un dépaysement radical pour un budget maîtrisé. Marrakech, Essaouira, Agadir, Fès, Ouarzazate : chaque destination raconte une histoire différente. Nous privatisons des riads, organisons des dîners sous les étoiles dans le désert d'Agafay et des soirées berbères dans l'Atlas.",
    body: [
      "Le Maroc combine une accessibilité aérienne exceptionnelle (vols directs depuis Paris, Lyon, Marseille, Bordeaux, Toulouse et Nice) et un rapport qualité-prix imbattable pour un dépaysement 5★. Marrakech, la ville rouge, est notre destination phare pour les incentives haut de gamme : palaces mythiques (La Mamounia, Royal Mansour, Selman, Palais Namaskar), riads privatisables de la médina et villas privées de la Palmeraie.",
      "Nos programmes signature au Maroc : traversée du désert d'Agafay en quad ou dromadaire suivie d'un dîner bivouac privatisé, cours de cuisine dans un riad avec un dada, initiation au surf à Essaouira, ski dans l'Atlas à Oukaïmeden (novembre-avril), montgolfière au-dessus de la palmeraie, soirées gnawa dans le désert.",
    ],
    cities: ["Marrakech", "Essaouira", "Agadir", "Fès", "Ouarzazate", "Casablanca"],
    activities: [
      "Bivouac privatisé désert d'Agafay",
      "Traversée en quad ou en dromadaire",
      "Soirée berbère dans un riad de la médina",
      "Cours de cuisine marocaine avec un dada",
      "Ski dans l'Atlas (Oukaïmeden)",
      "Montgolfière au-dessus de la Palmeraie",
    ],
    duration: "3 à 7 jours",
    from: "3h de vol de Paris",
  },
  canada: {
    slug: "canada",
    name: "Canada",
    flag: "🇨🇦",
    tagline: "L'aventure grandeur nature.",
    hero: "https://images.pexels.com/photos/756790/pexels-photo-756790.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/1596922/pexels-photo-1596922.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/1055170/pexels-photo-1055170.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/2946962/pexels-photo-2946962.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Canada, voyage entreprise Québec Montréal Vancouver. Séminaires et incentives corporate au Canada — chalets privatisés, motoneige, canoë, forêts boréales.",
    seoKeywords:
      "team building Canada, voyage entreprise Canada, incentive Québec, séminaire Montréal, team building Québec, voyage incentive Toronto, séminaire entreprise Canada, voyage groupe Canada, incentive motoneige, séjour entreprise Vancouver",
    intro:
      "Le Canada, c'est l'aventure à l'état pur pour des équipes en quête d'authenticité. Québec pour son charme européen, Montréal pour sa vie urbaine, Vancouver pour l'océan et les montagnes, les Laurentides pour la nature intacte.",
    body: [
      "Le Canada est la destination idéale pour les incentives ambitieux : dépaysement total, activités outdoor d'exception, hébergements premium (Fairmont Le Château Frontenac, Manoir Richelieu, Estérel Resort) et une culture francophone qui facilite les échanges. Le meilleur ratio prestige/authenticité pour vos meilleures équipes ou vos clients VIP.",
      "Nos incentives Canada s'articulent autour des saisons : hiver polaire (motoneige, traîneau à chiens, cabane à sucre, hôtel de glace) ou été indien (canoë, kayak sur le fleuve Saint-Laurent, randonnée dans les parcs nationaux, chasse aux baleines à Tadoussac). Combinaisons possibles avec un city trip Montréal ou Toronto pour la partie plus corporate.",
    ],
    cities: ["Québec", "Montréal", "Toronto", "Vancouver", "Ottawa", "Laurentides"],
    activities: [
      "Traîneau à chiens dans les Laurentides",
      "Motoneige et hôtel de glace",
      "Cabane à sucre traditionnelle",
      "Canoë sur le fleuve Saint-Laurent",
      "Observation des baleines à Tadoussac",
      "Randonnée en forêt boréale + soirée feu de camp",
    ],
    duration: "5 à 8 jours",
    from: "7h de vol de Paris",
  },
  espagne: {
    slug: "espagne",
    name: "Espagne",
    flag: "🇪🇸",
    tagline: "Le soleil et la fiesta à portée de vol.",
    hero: "https://images.pexels.com/photos/1388030/pexels-photo-1388030.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/1388030/pexels-photo-1388030.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/262047/pexels-photo-262047.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/1470502/pexels-photo-1470502.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Espagne, voyage entreprise Barcelone Madrid Ibiza. Séminaire entreprise Espagne clé-en-main — hôtels 5★ Boutique, villas privées, régates, tapas tour.",
    seoKeywords:
      "team building Espagne, voyage entreprise Espagne, incentive Barcelone, séminaire Madrid, team building Ibiza, voyage incentive Séville, séminaire entreprise Barcelone, voyage groupe Espagne, incentive Andalousie, séjour entreprise Valence",
    intro:
      "L'Espagne, c'est l'incentive facile et efficace : 2h de vol, tarifs maîtrisés, hôtels 5★ à foison, art de vivre inégalable. Barcelone pour l'architecture Gaudí, Madrid pour la vie nocturne, Ibiza pour les villas privées, l'Andalousie pour l'authenticité, Valence pour l'AmericasCup.",
    body: [
      "Nous privatisons des fincas dans les Baléares, organisons des régates à Palma, des dîners privatisés dans les caves de Rioja, des tapas tours à Séville et des tournois de padel à Marbella. L'Espagne offre une infrastructure hôtelière et de restauration idéale pour les groupes corporate, avec un rapport qualité-prix imbattable en Europe.",
      "Barcelone reste notre destination #1 pour les séminaires corporate : hôtels 5★ en front de mer (W Barcelona, Hotel Arts, Majestic), rooftops privatisables, réceptifs francophones, aéroport El Prat à 20 min du centre. Pour un mix travail/loisirs de très haut niveau.",
    ],
    cities: ["Barcelone", "Madrid", "Ibiza", "Séville", "Valence", "Marbella"],
    activities: [
      "Régate privée à Palma de Majorque",
      "Tapas tour dans le vieux Séville",
      "Cours de cuisine paella à Valence",
      "Tournoi de padel à Marbella",
      "Dégustation de vins Rioja & Ribera del Duero",
      "Villa privée à Ibiza + DJ set",
    ],
    duration: "3 à 5 jours",
    from: "2h de vol de Paris",
  },
  egypte: {
    slug: "egypte",
    name: "Égypte",
    flag: "🇪🇬",
    tagline: "5 000 ans d'histoire pour vos équipes.",
    hero: "https://images.pexels.com/photos/1837605/pexels-photo-1837605.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/262780/pexels-photo-262780.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/2412603/pexels-photo-2412603.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/3573382/pexels-photo-3573382.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Égypte, voyage entreprise Le Caire Louxor Assouan. Séminaire d'entreprise sur le Nil, croisière privée, pyramides — organisation clé-en-main.",
    seoKeywords:
      "team building Égypte, voyage entreprise Égypte, incentive Le Caire, séminaire Louxor, croisière Nil entreprise, voyage incentive Égypte, séminaire d'entreprise Égypte, voyage groupe Égypte, incentive pyramides, team building Sharm el-Sheikh",
    intro:
      "L'Égypte, c'est le voyage qui marque à vie. Les pyramides de Gizeh, les temples de Louxor et Karnak, une croisière privée sur le Nil, les eaux turquoise de la mer Rouge : aucun autre incentive n'offre une telle densité culturelle à un tarif aussi maîtrisé.",
    body: [
      "L'Égypte est notre destination coup de cœur pour les incentives 'wow-effect'. Nos programmes combinent le culturel (Le Caire, pyramides de Gizeh, Musée National, Louxor, Vallée des Rois, Assouan, temple d'Abou Simbel) et le loisir (croisière privée sur le Nil à bord d'une dahabieh, plongée en mer Rouge à Sharm el-Sheikh ou Hurghada, dîner sous les étoiles au pied des pyramides).",
      "Un incentive Égypte, c'est aussi la garantie d'une expérience inoubliable pour vos collaborateurs : nuit dans un palace du Caire (Marriott Mena House avec vue directe sur les pyramides), dîner privatisé au son quotidien-lumière de Karnak, dégustation de thé à la menthe dans un souk. Une programmation exigeante mais toujours confortable — nous travaillons avec les meilleurs guides francophones du pays.",
    ],
    cities: ["Le Caire", "Louxor", "Assouan", "Sharm el-Sheikh", "Hurghada", "Alexandrie"],
    activities: [
      "Croisière privée sur le Nil (dahabieh)",
      "Dîner privatisé au pied des pyramides de Gizeh",
      "Vol en montgolfière au-dessus de la Vallée des Rois",
      "Plongée en mer Rouge (récifs coralliens uniques)",
      "Visite privée du Musée du Caire hors horaires",
      "Fête bédouine dans le désert du Sinaï",
    ],
    duration: "6 à 10 jours",
    from: "4h30 de vol de Paris",
  },
  antilles: {
    slug: "antilles",
    name: "Antilles",
    flag: "🇫🇷",
    tagline: "L'exotisme français sans passeport.",
    hero: "https://images.pexels.com/photos/1450353/pexels-photo-1450353.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/1878293/pexels-photo-1878293.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/38238/maldives-ile-beach-sun-38238.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/2078265/pexels-photo-2078265.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Antilles, voyage entreprise Guadeloupe Martinique. Incentives corporate aux Antilles — plages, voile, rhum, hôtels 5★ Karibea Sofitel LeBrelin.",
    seoKeywords:
      "team building Antilles, voyage entreprise Antilles, incentive Guadeloupe, séminaire Martinique, voyage incentive Caraïbes, séminaire entreprise Guadeloupe, voyage groupe Antilles, incentive Martinique, team building plage, séjour entreprise Caraïbes",
    intro:
      "Guadeloupe et Martinique : l'exotisme total dans le confort d'un territoire français. Pas de visa, euros, sécurité, cadre juridique connu — et pourtant un dépaysement absolu. L'incentive idéal pour vos meilleurs performers.",
    body: [
      "Les Antilles françaises combinent tout ce que recherchent les DRH et Direction Générale : dépaysement 5★ garanti, hôtels de rêve (La Toubana, Auberge de la Vieille Tour, Cap Est Lagoon Resort), plages désertes, culture créole vibrante, cuisine étoilée. Le vol dure 8h mais aucun décalage horaire : vos équipes sont opérationnelles dès le lendemain.",
      "Notre offre Antilles : privatisation de plage, régate Ti Punch entre les îles, plongée en apnée sur les Îlets Pigeon (réserve Cousteau), spectacle de danses créoles, dégustation dans les distilleries de rhum agricole (Depaz, Neisson, Damoiseau), randonnée à la Soufrière ou à la Montagne Pelée. Une déconnexion totale sans jamais quitter le territoire français.",
    ],
    cities: ["Pointe-à-Pitre", "Basse-Terre", "Fort-de-France", "Sainte-Anne", "Les Anses-d'Arlet", "Terre-de-Haut"],
    activities: [
      "Régate privée dans l'archipel des Saintes",
      "Plongée sur la réserve Cousteau",
      "Dégustation rhum agricole (Depaz, Neisson)",
      "Randonnée volcan Soufrière ou Montagne Pelée",
      "Spectacle de danse créole (biguine, zouk)",
      "Soirée feu de plage à Sainte-Anne",
    ],
    duration: "5 à 8 jours",
    from: "8h de vol de Paris (vol direct)",
  },
  croatie: {
    slug: "croatie",
    name: "Croatie",
    flag: "🇭🇷",
    tagline: "La perle méditerranéenne encore préservée.",
    hero: "https://images.pexels.com/photos/2907577/pexels-photo-2907577.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/2907577/pexels-photo-2907577.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/1287460/pexels-photo-1287460.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/2830039/pexels-photo-2830039.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Croatie, voyage entreprise Split Dubrovnik Zagreb. Séminaires et incentives corporate en Croatie — Dalmatie, îles privatisées, régates.",
    seoKeywords:
      "team building Croatie, voyage entreprise Croatie, incentive Dubrovnik, séminaire Split, voyage incentive Dalmatie, séminaire entreprise Croatie, voyage groupe Croatie, incentive régate Adriatique, team building Zagreb, séjour entreprise Hvar",
    intro:
      "La Croatie est le secret le mieux gardé de la Méditerranée : 1 200 îles, une mer transparente, des villes UNESCO (Dubrovnik, Split, Trogir) et une infrastructure hôtelière qui a explosé depuis 10 ans — le tout à des tarifs bien inférieurs à l'Italie ou la France.",
    body: [
      "Nos incentives Croatie sont construits autour de la navigation dans les Kornati ou le long de la côte dalmate : privatisation de yachts avec skipper, régates entre les îles, soirées privatisées sur Hvar, Vis ou Brac. Combinaison avec visites de Dubrovnik (mur d'enceinte, Game of Thrones), Split (Palais de Dioclétien), Zadar et son orgue marin.",
      "Croatie : le meilleur rapport dépaysement-luxe-tarif de la Méditerranée. Hôtels 5★ (Excelsior Dubrovnik, Hotel Adriatic Hvar, Villa Dubrovnik) sans exploser le budget, gastronomie truffe et poisson frais, plages sauvages et vin natif (Plavac Mali).",
    ],
    cities: ["Dubrovnik", "Split", "Zagreb", "Hvar", "Zadar", "Rovinj"],
    activities: [
      "Régate privée dans les îles Kornati",
      "Privatisation d'un yacht + skipper",
      "Soirée sunset à Hvar (Carpe Diem)",
      "Kayak dans la baie de Dubrovnik",
      "Dégustation de vins et huile d'olive en Istrie",
      "Tour Game of Thrones à Dubrovnik",
    ],
    duration: "5 à 7 jours",
    from: "2h20 de vol de Paris",
  },
  belgique: {
    slug: "belgique",
    name: "Belgique",
    flag: "🇧🇪",
    tagline: "L'incentive express au cœur de l'Europe.",
    hero: "https://images.pexels.com/photos/2739663/pexels-photo-2739663.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/2739663/pexels-photo-2739663.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/1796730/pexels-photo-1796730.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/13023300/pexels-photo-13023300.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Belgique, voyage entreprise Bruxelles Bruges Anvers. Séminaires corporate en Belgique — chocolat, bière, patrimoine médiéval.",
    seoKeywords:
      "team building Belgique, voyage entreprise Belgique, incentive Bruxelles, séminaire Bruges, team building Anvers, voyage incentive Bruxelles, séminaire entreprise Belgique, voyage groupe Belgique, incentive bière belge, séjour entreprise Bruges",
    intro:
      "1h20 de Thalys depuis Paris, la Belgique offre un incentive express de très haut niveau : Bruxelles pour l'Europe institutionnelle, Bruges pour le charme médiéval, Anvers pour la mode et le diamant, Gand pour l'authenticité.",
    body: [
      "Un incentive Belgique, c'est l'assurance d'un séjour rapide, francophone (partiellement) et gastronomique. Nous privatisons des brasseries mythiques (Cantillon, Delirium, De Halve Maan à Bruges), organisons des ateliers chocolat (Marcolini, Neuhaus), des dégustations de bières trappistes, des balades en calèche à Bruges, des tours street-art à Bruxelles.",
    ],
    cities: ["Bruxelles", "Bruges", "Anvers", "Gand", "Namur", "Liège"],
    activities: [
      "Atelier chocolat privatisé (Marcolini)",
      "Dégustation bières trappistes Chimay/Orval",
      "Balade en calèche à Bruges",
      "Tour street-art à Bruxelles",
      "Visite privée du diamantaire à Anvers",
      "Bataille d'échec géant Grand-Place Bruxelles",
    ],
    duration: "2 à 4 jours",
    from: "1h20 de Thalys",
  },
  suisse: {
    slug: "suisse",
    name: "Suisse",
    flag: "🇨🇭",
    tagline: "L'excellence alpine au service de vos équipes.",
    hero: "https://images.pexels.com/photos/572897/pexels-photo-572897.jpeg?auto=compress&cs=tinysrgb&w=1920",
    gallery: [
      "https://images.pexels.com/photos/572897/pexels-photo-572897.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/1666021/pexels-photo-1666021.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/3389851/pexels-photo-3389851.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    seoDesc:
      "Team building Suisse, voyage entreprise Genève Zermatt Zurich. Séminaires alpins et lacs suisses — Verbier, Interlaken, hôtels palaces, incentive premium.",
    seoKeywords:
      "team building Suisse, voyage entreprise Suisse, incentive Genève, séminaire Zermatt, team building Alpes suisses, voyage incentive Zurich, séminaire entreprise Suisse, voyage groupe Suisse, incentive ski Verbier, séjour entreprise Interlaken",
    intro:
      "Genève, Zermatt, Verbier, Interlaken, Zurich : la Suisse est LA destination premium pour vos meilleurs cadres et clients. Hôtels palaces, gastronomie 3★, paysages alpins, sécurité absolue et proximité (2h de TGV depuis Lyon).",
    body: [
      "Nos incentives Suisse jouent la carte de l'exceptionnel : nuit au Badrutt's Palace de Saint-Moritz, dîner sur les hauteurs de Verbier au Chalet d'Adrien, spa d'altitude au Cambrian d'Adelboden, tour du Mont-Blanc en hélicoptère. La Suisse est chère mais c'est le prix de l'expérience irréprochable pour vos VIP.",
    ],
    cities: ["Genève", "Zermatt", "Verbier", "Interlaken", "Zurich", "Saint-Moritz"],
    activities: [
      "Ski et hors-piste à Verbier ou Zermatt",
      "Tour du Mont-Blanc en hélicoptère",
      "Fondue et raclette dans un chalet d'alpage",
      "Croisière sur le lac Léman",
      "Visite privée d'une manufacture horlogère (Genève)",
      "Escalade de la Jungfrau (Interlaken)",
    ],
    duration: "3 à 5 jours",
    from: "2h de TGV depuis Lyon",
  },
};

export const DESTINATION_ORDER = ["maroc", "espagne", "canada", "egypte", "antilles", "croatie", "belgique", "suisse"];
